// This is just an example,
// so you can safely delete all default props below

export default {
  failed: 'Akce skončena neúspěchem',
  success: 'Akce skončena úspěšně',
  message: {
    search: 'Hledat ...'
  },
  layout: {
    application: {
      title: 'DATABÁZE RESTAUROVANÝCH PŘEDMĚTŮ ',
      subtitle: 'VŠCHT Praha'
    }
  },
  facets: {
    archeologic_label: 'Archeologický nález',
    archeologic_0: 'Ne',
    archeologic_1: 'Ano',
    creator_label: 'Autor záznamu',
    category_label: 'Kategorie',
    keywords_label: 'Klíčová slova',
    submissionStatus_label: 'Stav záznamu',
    submissionStatus_incomplete: 'Nedokončený',
    submissionStatus_pending_approval: 'Čeká na schválení',
    submissionStatus_submitted: 'Schválený',
    parts_color_title_value_keyword_label: 'Barva',
    parts_fabricationTechnology_title_value_keyword_label: 'Technologie výroby',
    parts_materialType_title_value_keyword_label: 'Typy materiálu',
    parts_restorationMethods_title_value_keyword_label: 'Metody restaurování',
    itemType_title_value_keyword_label: 'Typ předmětu',
    restorationRequestor_title_value_keyword_label: 'Zadavatel restaurování',
    stylePeriod_title_value_keyword_label: 'Sloh',
    works_metadata_restorationPeriod_until_label: 'Rok odevzdání práce'
  }
}
